// Purchase model line
import proxy from "api/proxy";
import mainStore from "store/mainStore";

const getProduct = (value) => {
  const search = [
    "OR",
    [
      ["template.name", "ilike", `%${value}%`],
      ["template.purchasable", "=", true],
    ],
    [
      ["code", "ilike", `${value}%`],
      ["template.purchasable", "=", true],
    ],
  ];
  return search;
};

const onChangeProduct = async (record) => {
  if (record?.product) {
    const taxes = await getTaxes(record.product.id);
    record.description = record.product.name;
    record.taxes = taxes;
    const purchaseUom = record.product["template."]?.["purchase_uom."];

    if (purchaseUom) {
      record.unit = {
        id: purchaseUom.id,
        name: purchaseUom.rec_name,
      };
    } else {
      record.unit = null;
    }
  }
};

const onChangeQty = (activeRecord) => {
  if (activeRecord.unit_price) {
    let price_w_tax = Number(activeRecord.unit_price.replace(/[^0-9.-]+/g, ""));
    if (activeRecord.taxes) {
      if (activeRecord.taxes.percentage > 0) {
        price_w_tax *= 1 + activeRecord.taxes.percentage;
      }
      if (activeRecord.taxes.fixed > 0) {
        price_w_tax += activeRecord.taxes.fixed;
      }
    }
    const amount =
      price_w_tax * Number(activeRecord.quantity.replace(/[^0-9.-]+/g, ""));
    activeRecord.amount = amount;
  }
};

const getTaxes = async (product) => {
  const { data } = await proxy.methodCall({
    model: "purchase.purchase",
    method: "dash_get_taxes",
    args: [{ id: product }],
  });
  return data;
};

const onChangeUnitPrice = (activeRecord) => {
  const { quantity, unit_price, taxes } = activeRecord;
  if (quantity) {
    let price_w_tax = Number(unit_price.replace(/[^0-9.-]+/g, ""));
    if (taxes.percentage > 0) {
      price_w_tax *= 1 + taxes.percentage;
    }
    if (taxes.fixed > 0) {
      price_w_tax += taxes.fixed;
    }
    const amount = price_w_tax * Number(quantity.replace(/[^0-9.-]+/g, ""));
    activeRecord.amount = amount;
  }
};

const getStatusLine = () => {
  const { record: recordParent } = mainStore.getState();
  return ["done", "processing", "quotation"].includes(recordParent.state);
};

const getView = () => {
  Array.prototype.insert = function (index, item) {
    this.splice(index, 0, item);
  };
  const DictCtxView = {
    form_action_add: "modal",
    model: "purchase.line",
    form_action: ["delete", "add", "edit"],
    table_action: ["edit", "add"],
    row_selectable: false,
    validate_state: true,
    target: "purchase",
    webfields: {
      product: {
        type: "many2one",
        model: "product.product",
        recSearch: getProduct,
        withChange: onChangeProduct,
        attrs: ["id", "name", "template.purchase_uom.rec_name"],
        required: true,
        readOnly: getStatusLine,
      },
      quantity: {
        type: "numeric",
        withChange: onChangeQty,
        required: true,
        decimalPlaces: 2,
        readOnly: getStatusLine,
      },
      unit: {
        type: "many2one",
        model: "product.uom",
        readOnly: true,
      },
      unit_price: {
        type: "numeric",
        withChange: onChangeUnitPrice,
        required: true,
        decimalPlaces: 4,
        readOnly: getStatusLine,
      },
      state: { type: "char" },
      description: { type: "char", readOnly: getStatusLine },
      amount: { type: "numeric", readOnly: true, decimalPlaces: 2 },
    },
    webtree: [
      { name: "product", width: "30%" },
      { name: "quantity", width: "10%" },
      { name: "unit", width: "10%" },
      { name: "unit_price", width: "15%" },
      { name: "amount", width: "15%" },
      { name: "description", width: "30%" },
    ],
    webform: [
      { name: "product" },
      { name: "quantity", component: "increment" },
      { name: "unit" },
      { name: "unit_price" },
      { name: "amount" },
      { name: "description" },
    ],
  };

  return DictCtxView;
};

export default { ctxView: getView };
